import { Application } from './application';

const isApplication = (applicationOrFirstName: Application | string) =>
  typeof applicationOrFirstName !== 'string';

export function getApplicationFullName(application: Application): string;
export function getApplicationFullName(firstName: string, lastName: string): string;
export function getApplicationFullName(
  applicationOrFirstName: Application | string,
  _lastName?: string
): string {
  const firstName = isApplication(applicationOrFirstName)
    ? applicationOrFirstName.firstName
    : applicationOrFirstName;
  const lastName = isApplication(applicationOrFirstName)
    ? applicationOrFirstName.lastName
    : _lastName;

  return `${firstName.trim()} ${lastName?.trim()}`.trim();
}
